module.exports = __webpack_public_path__ + "img/fla.75f6e210.svg";